import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import jwtService from 'jwtService';
import { ActionTypes } from 'constants/index';
import { showMessage, hideMessage, logoutUser, setUserData, submitLoginwithToken, setUserDetailsLoading } from 'store/actions'
import { checkEmailForLLSE, checkEmailFromUER, checkEmailForAad } from 'store/actions';
// import useIdleTimer from './useIdleTimer';

import PreAppLoading from 'components/PreAppLoading/PreAppLoading';
import { getSubdomain } from 'utility/url';

// Debug logger - enable via localStorage.setItem('debugSSO', 'true')
const debugLog = (...args) => {
    const isDebug = localStorage.getItem('debugSSO') === 'true'
    if (isDebug) console.log('[Auth]', ...args)
}

class Auth extends Component {
    /*eslint-disable-next-line no-useless-constructor*/
    constructor(props) {
        super(props);

        /**
         * Comment the line if you do not use JWt
         */
        this.jwtCheck();

        // Below code will be used to find the idle/active time
        // const { isIdle, activeDuration } = useIdleTimer(
        //     9 * 60 * 1000, // 9 minutes active time
        //     10 * 60 * 1000, // 10 minutes idle time
        //     () => {
        //         console.log("User has been actively using the app for 9 minutes!");
        //         this.onFocus();
        //     },
        //     () => {
        //         console.log("User has been idle for 10 minutes across all tabs!");
        //         jwtService.logout()
        //     }
        // );
        // this.isIdle = isIdle
        // this.activeDuration = activeDuration
    }

    componentDidMount() {
        // Comment to make it work in local
        //TODO: We need to check why it is failing
        // This will execute only when user click inside the page
        // window.addEventListener("focus", this.onFocus)
    }

    onFocus = () => {
        console.log("onFocus - invoked")
        let isSsoLogin = localStorage.getItem('isSsoLogin')
        let isAdLogin = localStorage.getItem('isAdLogin')
        // Refresh token is only required for dSilo registry
        if (!isSsoLogin && !isAdLogin) {
            /**
             * RT should called when its only dSilo registry
             * When in loop
             *  1. RT should be called only when document.visibilityState === "visible"
             *  2. RT should be called if last refresh token in only 10 mins before
             *  3. If user start using the application 
             *  4. then RT should be called for every 9 mins
             *  5. If user is not using the application then he should be logged out.
             *  6. If user leaves the tab
             *      1. then RT should be called
             *  8. If user comes back to the tab
             *      1. if its been less than ten minutes 
             *      2. then RT should not be called
             *      3. then call RT should be called
             *  
             */

            // console.log("this.isIdle ======", this.isIdle)
            // Refresh token
            jwtService.refreshToken();
        }
    }

    jwtCheck = async () => {
        debugLog("=== jwtCheck START (called from constructor) ===");
        
        const jwt_access_token = localStorage.getItem('jwt_access_token');
        const ssoRedirect = localStorage.getItem('ssoRedirect');
        const isSsoRedirectSuccess = localStorage.getItem('isSsoRedirectSuccess');
        // SSO re-direct, when `gsk-uat` found in url
        console.log("App component mounted", location.hostname);
        console.log("jwt_access_token", jwt_access_token);
        console.log("ssoRedirect", ssoRedirect);
        if (
            // location.hostname.includes("gsk-uat") ||
            (!location.hostname.includes("platform") && !location.hostname.includes("internal"))
            // Localhost should not redirect to SSO
            && location.hostname !== "localhost"
            // jwt_access_token is already available then no need to redirect to SSO
            // TODO: Need more analysis on this check with valid SSO system
            && (!jwt_access_token || !jwtService.isAuthTokenValid(jwt_access_token))
            // SSO redirect is already done, no need to do it again
            && !ssoRedirect
            // SSO redirect is success, no need to do it again
            && !isSsoRedirectSuccess
        ) {
            // As we need to redirect user to SSO system, we are not using redux store directly

            const subDomain = getSubdomain();
            console.log(subDomain); // "client-platform"

            let success = await jwtService.checkEmailForLLSE({ llse: subDomain, sd: true }).then(output => {
                console.log("output", output)
                const finalConfig = output?.data?.ssoConfig

                if(finalConfig?.saml?.ssoURL) {
                    localStorage.setItem(`ssoRedirect`, true);
                    if (finalConfig?.SAMLRequest) {
                        window.location.replace(`${finalConfig?.saml?.ssoURL}?SAMLRequest=${finalConfig?.SAMLRequest}`);
                    } else {
                        window.location.replace(finalConfig?.saml?.ssoURL);
                    }
                    return true
                }
                return false
            })
            if(!success) return
        }

        /** commented as not being used currently, will be used in future */
        // jwtService.on('onAutoLogin', () => {

        //     this.props.showMessage({ message: 'Logging in with JWT' });

        //     /**
        //      * Sign in and retrieve user data from Api
        //      */
        //     this.props.setUserDetailsLoading(true)
        //     jwtService.signInWithToken()
        //         .then(user => {
        //             console.log("user", user);
        //             if (user) {
        //                 this.props.submitLoginwithToken(user);
        //                 this.props.setUserData(user);
        //                 this.props.showMessage({ message: 'Logged in with JWT' });
        //             }
        //             this.props.setUserDetailsLoading(false)
        //         })
        //         .catch(error => {
        //             this.props.showMessage({ message: error });
        //             this.props.setUserDetailsLoading(false)
        //         })
        // });

        // jwtService.on('onAutoLogout', (message) => {
        //     if (message) {
        //         this.props.showMessage({ message });
        //     }
        //     this.props.logout();
        // });

        // SSO process

        // SSO load, when `llse` found in localStorage
        const llse = localStorage.getItem('llse');
        const isSsoLogin = localStorage.getItem('isSsoLogin');
        const userEmailReport = localStorage.getItem('userEmailReport');
        // const ssoRedirect = localStorage.getItem('ssoRedirect');

        const { isCheckEmailLLSEComplete } = this.props.login

        // Debug each condition for llse SSO trigger
        debugLog("=== Auth SSO Check ===")
        debugLog("1. llse:", llse, "→", !!llse ? "✓" : "✗")
        debugLog("2. !ssoRedirect:", !ssoRedirect, "(ssoRedirect:", ssoRedirect, ") →", !ssoRedirect ? "✓" : "✗")
        debugLog("3. !jwt_access_token || !isAuthTokenValid:", (!jwt_access_token || !jwtService.isAuthTokenValid(jwt_access_token)), "(jwt_access_token:", !!jwt_access_token, ") →", (!jwt_access_token || !jwtService.isAuthTokenValid(jwt_access_token)) ? "✓" : "✗")
        debugLog("4. !isCheckEmailLLSEComplete:", !isCheckEmailLLSEComplete, "(isCheckEmailLLSEComplete:", isCheckEmailLLSEComplete, ") →", !isCheckEmailLLSEComplete ? "✓" : "✗")
        debugLog("5. !userEmailReport:", !userEmailReport, "(userEmailReport:", !!userEmailReport, ") →", !userEmailReport ? "✓" : "✗")
        debugLog("6. !manualLogout:", !this.props.user?.manualLogout, "(manualLogout:", this.props.user?.manualLogout, ") →", !this.props.user?.manualLogout ? "✓" : "✗")
        debugLog("=== End SSO Check ===")
        
        // manualLogout check: Blocks LLSE immediately after logout (same session).
        // On page refresh, manualLogout is cleared in reducer (REHYDRATE), so LLSE triggers.
        if (llse
            // && !isSsoLogin 
            && !ssoRedirect
            && (!jwt_access_token || !jwtService.isAuthTokenValid(jwt_access_token))
            && !isCheckEmailLLSEComplete && !userEmailReport && !this.props.user?.manualLogout) {
            debugLog("✓ PATH 1: All conditions met - triggering checkEmailForLLSE");
            debugLog("→ Dispatching checkEmailForLLSE with llse:", llse);
            this.props.checkEmailForLLSE({ llse })
            debugLog("→ checkEmailForLLSE dispatched! Waiting for componentDidUpdate...");
        } else if (!isCheckEmailLLSEComplete && userEmailReport
            // && !isSsoLogin 
            && !ssoRedirect
            && (!jwt_access_token || !jwtService.isAuthTokenValid(jwt_access_token))
            && !this.props.user?.manualLogout) {
            debugLog("✓ PATH 2: userEmailReport found in localStorage, triggering SSO");
            debugLog("→ Dispatching checkEmailFromUER with userEmailReport");
            this.props.checkEmailFromUER({ userEmailReport })
            debugLog("→ checkEmailFromUER dispatched! Waiting for componentDidUpdate...");
        } else {
            debugLog("✗ No SSO path taken. Conditions summary:");
            debugLog("  - llse exists:", !!llse);
            debugLog("  - !ssoRedirect:", !ssoRedirect, "(ssoRedirect:", ssoRedirect, ")");
            debugLog("  - no valid token:", (!jwt_access_token || !jwtService.isAuthTokenValid(jwt_access_token)));
            debugLog("  - !isCheckEmailLLSEComplete:", !isCheckEmailLLSEComplete);
            debugLog("  - !userEmailReport:", !userEmailReport);
            debugLog("  - !manualLogout:", !this.props.user?.manualLogout);
            debugLog("  PATH 1 would need: llse && !ssoRedirect && noValidToken && !isCheckEmailLLSEComplete && !userEmailReport && !manualLogout");
            debugLog("  PATH 2 would need: !isCheckEmailLLSEComplete && userEmailReport && !ssoRedirect && noValidToken && !manualLogout");
        }

        debugLog("=== End jwtCheck ===");
        // JWT init
        jwtService.init();
    };

    getDecryptedConfig = async (encryptedConfig, iv) => {
        if (encryptedConfig && typeof encryptedConfig === 'string' && iv) {
            // const decryptedConfig = await CryptoHelper.decodeData(encryptedConfig, iv, props?.secretKey)
            const decryptedConfig = encryptedConfig
            if (decryptedConfig) return JSON.parse(decryptedConfig);
            return null;
        }
        return encryptedConfig;
    }

    handleConfig = async (configType, configData) => {
        debugLog("=== handleConfig ===");
        debugLog("configType:", configType);
        debugLog("configData:", configData);
        debugLog(`${configType}Enable:`, configData?.[`${configType}Enable`]);
        debugLog(`${configType}Config exists:`, !!configData?.[`${configType}Config`]);
        
        if (configData?.[`${configType}Enable`] && configData?.[`${configType}Config`]) {
            debugLog("✓ Config enabled, getting decrypted config...");
            const decryptedConfig = await this.getDecryptedConfig(configData[`${configType}Config`], configData?.iv);
            debugLog("decryptedConfig:", decryptedConfig);
            debugLog("decryptedConfig.enable:", decryptedConfig?.enable);

            if (decryptedConfig && decryptedConfig.enable) {
                const finalConfig = {
                    ...decryptedConfig,
                    orgId: configData?.orgId
                };
                debugLog("finalConfig:", finalConfig);

                localStorage.setItem(`${configType}Config`, window.btoa(JSON.stringify(finalConfig)));
                debugLog(`✓ ${configType}Config saved to localStorage`);

                if (configType === 'ad') {
                    debugLog("→ AD path (not SSO)");
                    // AAD support
                } else if (configType === 'sso') {
                    debugLog("→ SSO path - setting ssoRedirect and redirecting...");
                    localStorage.setItem(`${configType}Redirect`, true);
                    const ssoURL = finalConfig?.SAMLRequest 
                        ? `${finalConfig?.saml?.ssoURL}?SAMLRequest=${finalConfig?.SAMLRequest}`
                        : finalConfig?.saml?.ssoURL;
                    debugLog("✓ Redirecting to SSO URL:", ssoURL);
                    if (finalConfig?.SAMLRequest) {
                        window.location.replace(`${finalConfig?.saml?.ssoURL}?SAMLRequest=${finalConfig?.SAMLRequest}`);
                    } else {
                        window.location.replace(finalConfig?.saml?.ssoURL);
                    }
                }
            } else {
                debugLog("✗ decryptedConfig or decryptedConfig.enable is falsy");
            }
        } else {
            debugLog(`✗ ${configType}Enable or ${configType}Config missing`);
        }
    };

    handleProcess = (emailCheckData) => {
        debugLog("=== handleProcess ===");
        debugLog("emailCheckData:", emailCheckData);
        debugLog("emailCheckData has keys:", emailCheckData && Object.keys(emailCheckData)?.length);
        
        if (emailCheckData && Object.keys(emailCheckData)?.length) {
            debugLog("adEnable:", emailCheckData?.adEnable);
            debugLog("ssoEnable:", emailCheckData?.ssoEnable);
            
            if (emailCheckData?.adEnable && emailCheckData?.adConfig) {
                debugLog("→ AD path");
                localStorage.setItem(`userEmailReport`, window.btoa(JSON.stringify(emailCheckData)))
                this.handleConfig('ad', emailCheckData);
            } else if (emailCheckData?.ssoEnable && emailCheckData?.ssoConfig) {
                debugLog("→ SSO path - saving userEmailReport and calling handleConfig('sso')");
                localStorage.setItem(`userEmailReport`, window.btoa(JSON.stringify(emailCheckData)))
                this.handleConfig('sso', emailCheckData);
            } else {
                debugLog("→ Neither AD nor SSO - saving userEmailResponse");
                localStorage.setItem(`userEmailResponse`, window.btoa(JSON.stringify(emailCheckData)))
            }
        } else {
            debugLog("✗ emailCheckData is empty or invalid");
        }
    }

    componentDidUpdate(prevProps) {
        // Compare previous props with current props
        debugLog("=== Auth componentDidUpdate ===");
        debugLog("prevProps.login?.emailCheckData:", prevProps.login?.emailCheckData);
        debugLog("this.props.login?.emailCheckData:", this.props.login?.emailCheckData);
        debugLog("emailCheckData changed:", prevProps.login?.emailCheckData !== this.props.login?.emailCheckData);
        
        if (prevProps.login?.emailCheckData !== this.props.login?.emailCheckData) {
            // Do something in response to prop change
            debugLog('✓ emailCheckData prop changed - calling handleProcess');
            debugLog('emailCheckData:', this.props.login?.emailCheckData);
            this.handleProcess(this.props.login?.emailCheckData)
        }
    }

    render() {
        const { children } = this.props;

        // SSO load, when `llse` found in localStorage
        const llse = localStorage.getItem('llse');
        const isSsoLogin = localStorage.getItem('isSsoLogin');
        const userEmailReport = localStorage.getItem('userEmailReport');
        const ssoRedirect = localStorage.getItem('ssoRedirect');
        const isSsoRedirectSuccess = localStorage.getItem('isSsoRedirectSuccess');

        const { isCheckEmailLLSEComplete, isCheckEmailLLSELoading } = this.props.login

        console.log("AUTH IN --==")
        console.log("ssoRedirect", !ssoRedirect, "isSsoRedirectSuccess", !isSsoRedirectSuccess)
        console.log("(!ssoRedirect || (ssoRedirect && !isSsoRedirectSuccess))", (!ssoRedirect || (ssoRedirect && !isSsoRedirectSuccess)))
        console.log("isCheckEmailLLSEComplete", !isCheckEmailLLSEComplete)
        console.log("isCheckEmailLLSELoading", isCheckEmailLLSELoading)
        console.log("llse", llse)

        // Show PreAppLoading when:
        // - llse exists AND
        // - (no ssoRedirect yet OR ssoRedirect started but not successful) AND
        // - email check not complete yet
        return (llse
            // && !isSsoLogin
            && !ssoRedirect
            && (ssoRedirect && !isSsoRedirectSuccess)
            && !isCheckEmailLLSEComplete)
            ? <PreAppLoading />
            : <React.Fragment>
                {children}
            </React.Fragment>
    }
}

const mapStateToProps = state => {
    return {
        login: state.login,
        apps: state.app,
        user: state.user,
    };
};

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        logout: logoutUser,
        setUserData: setUserData,
        submitLoginwithToken: submitLoginwithToken,
        showMessage: showMessage,
        hideMessage: hideMessage,
        setUserDetailsLoading: setUserDetailsLoading,

        // SSO LLSE
        checkEmailForLLSE,
        checkEmailFromUER,
        checkEmailForAad

    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Auth);
